module.exports = __webpack_public_path__ + "static/img/subcontract11.1185bf4e.png";